<template>
<div>
    <!--  Change Password Form  -->
    <section class="container-fluid  chng-pd-container">
        <div class="container form-container">
            <div class="row">
                <form class="w-100">
                    <div class="heading">
                        <h2>change password</h2>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-lg-12">
                            <div class="d-flex flex-row">
                                <label for="current_password">Current Password</label>
                                <span class="red">*</span>
                            </div>
                            <input type="password"
                            v-model="form.current_password"
                            class="form-control"
                            id="current_password"
                            placeholder="Current Password"
                            :class="{ 'is-invalid': form.errors.has('current_password') }">
                            <has-error :form="form" field="current_password"></has-error>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-lg-12">
                            <div class="d-flex flex-row">
                                <label for="new_password">New Password</label>
                                <span class="red">*</span>
                            </div>
                            <input type="password"
                            v-model="form.new_password"
                            class="form-control"
                            id="new_password"
                            placeholder="New Password"
                            :class="{ 'is-invalid': form.errors.has('new_password') }"
                            >
                            <has-error :form="form" field="new_password"></has-error>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-lg-12">
                            <div class="d-flex flex-row">
                                <label for="confirm_password">Confirm New Password</label>
                                <span class="red">*</span>
                            </div>
                            <input type="password"
                            v-model="form.confirm_password"
                            class="form-control"
                            id="confirm_password"
                            placeholder="Confirm Password"
                            :class="{ 'is-invalid': form.errors.has('confirm_password') }"
                            >
                            <has-error :form="form" field="confirm_password"></has-error>
                        </div>
                    </div>
                    <div class="form-row button justify-content-center">
                        <button @click.prevent="updatePassword" type="submit" class="btn btn-success">UPDATE</button>
                    </div>
                </form>
            </div>
        </div>
    </section>
</div>
</template>

<script>
 
export default {
    name: "Change_password",
    components: { 
       
    },
    data() {
        return {
                 form: new Form({
                    id:'',
                    password: '',
                })
            }
    },

    methods: {
                 updatePassword(){ 
                this.form.post('api/change-password')
                .then((data)=>{
                    if(response.data.success==true){
                    if($cookies.isKey('anch_remember_me')){
                        this.$cookies.set("anch_log_pass", this.form.new_password, "340d")
                    }
                }
                    //  Fire.$emit('AfterCreate');
                     
                    this.form.current_password = '';
                    this.form.new_password = '';
                    this.form.confirm_password = '';

                    Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                })
                .catch(() => { 
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                });
            }
    }
}

</script>

<style scoped>

</style>